// Library Imports
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// Local Imports
import loginUserSlice from './features/loginUser/loginUserSlice';
import authUserSlice from './features/auth/authSlice';
import userSlice from './features/users/userSlice';
import servicesSlice from './features/services/servicesSlice';
import salonSlice from './features/salon/salonSlice';
import bookingsSlice from './features/bookings/bookingsSlice';

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['currentUser'],
};

// Combine your reducers
const rootReducer = combineReducers({
  currentUser: loginUserSlice,
  authUser: authUserSlice,
  allUsers: userSlice,
  allServices: servicesSlice,
  allSalons: salonSlice,
  allBookings: bookingsSlice,
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with the persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

// Export types for the store and state
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Create a persistor
export const persistor = persistStore(store);

// Hooks Types
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
